// extracted by mini-css-extract-plugin
export default {"categoryLabel":"KhtPOpcbChSP8cniEp5L","categoryIcon":"A0uSSyCUTU5E1zoRrAIW","orderActions":"wFqlj_UU9LQagqdzMgsq","orderNumber":"E_Bn7rfERHs8wpMPSqPE"};